// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wTUzds3AcmNlobfriXq2 {
  max-width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/nft-skeleton/nft-skeleton.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB","sourcesContent":[".skeletonInner {\n  max-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skeletonInner": `wTUzds3AcmNlobfriXq2`
};
export default ___CSS_LOADER_EXPORT___;
